// extracted by mini-css-extract-plugin
export default {"error":"nyGV8","btn":"VN0B2"};